import React, { useEffect, useCallback, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import { Checkbox, Button } from '@mui/material'; 
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { listInvoiceMaintenance , updateInvoiceMaintenance, updateBulkInvoice} from '../../modules/invoiceMaintenanceModule/invoiceMaintenance';
import InvoiceMaintenanceList from '../../components/invoiceMaintenanceMng/InvoiceMaintenanceList';

import * as yup from 'yup';
import { useFormik } from 'formik';
import { InoviceMaintenanceSearchBox } from '../../components/invoiceMaintenanceMng/InoviceMaintenanceSearchBox';
import InvoiceLinModalConatiner from '../common/form/modal/InvoiceLineModalContainer';
import { listInvoiceApprovalLine } from   '../../modules/empModule/empApproval';
import moment from 'moment';

const InvoiceMaintenanceListContainer = ({ editFunction }) => {
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [selectionModel, setSelectionModel] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState("revVal2");
  const [searchWords, setSearchWords] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [pendingData, setPendingData] = useState(null);
  const { user } = useSelector((state) => state.auth);
  const { InvoiceMaintenanceListCall, loading, error } = useSelector((state) => {
    // 1. 원본 리스트 가져오기
    const rawList = state.invoiceMaintenanceModule.invoiceMaintenance.list || [];
    const err = state.invoiceMaintenanceModule.invoiceMaintenance.error;
    const isLoad = state.loading?.['invoiceMaintenance/LIST_INVOICE_MAINTENANCE'];
    
    // 2. 권한 필터링
    let filtered = user?.adminRole === 'Y' 
      ? rawList 
      : rawList.filter(item => item.dptUuid === user?.dptUuid);

    // 4. 최종 반환 (괄호 위치 확인)
    return {
      InvoiceMaintenanceListCall: filtered,
      loading: isLoad,
      error: err 
    };
  }); // 여기서 useSelector 닫음

  const [apprUuid, setApprUuid] = useState(null);
  const { invoiceLines } = useSelector(
    ({ empModule }) => ({
      invoiceLines: empModule.employeeApproval.invoiceLines,
    }),
  );

  useEffect(() => {
    if (invoiceLines) {
      setApprUuid(invoiceLines[0]?.apprUuid);
    } else {
      dispatch(listInvoiceApprovalLine());
    }
  }, [invoiceLines]);

  useEffect(() => {
    if (searchKeyword !== '' && searchWords !== '') {
      searchList(formik?.values);
    }
  }, []);

  const [message, setMessage] = useState('');
  
  const checkValidation = () => {
    let valid = true;

    if (apprUuid === '' || apprUuid === null) {
      valid = false;
      setMessage('결재선을 선택하세요.');
      return valid;
    }
  };

  
  const handleClose = () => {
    setOpenModal(false);
  };
    

  const searchList = (values) => {
    let searchData = {
      [values.searchKeyword]: values.searchWords,
      stDt: values.searchStrtDt ? dayjs(values.searchStrtDt).format('YYYY-MM-DD') : '',
      edDt: values.searchEndDt ? dayjs(values.searchEndDt).format('YYYY-MM-DD') : '',
      invYn: values.searchStatus ? values.searchStatus : '',
    };


    setSearchKeyword(values.searchKeyword);
    setSearchWords(values.searchWords);
    
    dispatch(listInvoiceMaintenance(searchData));

  }

  const getFirstDayOfYear = () => {
    const year = new Date().getFullYear();
    return `${year}-01-01`;
  };

  const getAfterWeek = () => {
    const date = new Date();
    date.setDate(date.getDate() + 6);
    return date.toISOString().split('T')[0]; 
  };

  const initialValues = {
    searchKeyword: 'cstNm', 
    searchWords: '',
    searchStrtDt: getFirstDayOfYear(),
    searchEndDt: getAfterWeek(), 
    searchStatus: 'N', 
  };


  const validationSchema = yup.object({
    searchKeyword: yup.string('').nullable(),
    searchWords: yup.string('').trim().nullable(),
  });

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values, { setSubmitting }) => {
      setSubmitting(true);
        searchList(values);
        setSubmitting(false);
    },
  });

  const mapRowToData = (row) => {
    // 숫자 변환 (null이나 undefined 대비 0 처리)
    const expSales = Number(row.expSales || 0);
    const salAmt = Number(row.salAmt || 0);
    const salBal = Number(row.salBal || 0);
    const salVat = Number(row.salVat || 0);

    // 요청하신 계산식 적용
    const calculatedValue = expSales - salAmt - salBal;
    return {
      waitUuid: row.id,
      prjUuid: row.prjUuid,
      invTyp: '매출',
      reqCompDt: row.salDt ? moment(row.salDt).format('YYYY-MM-DD') : '',
      partnerUuid: row.partnerUuid,
      partnerNm: row.partnerNm,
      invTxt: row.salDet,
      billSumTotal: expSales,
      billIssuedTotal: calculatedValue, 
      invAmt: salAmt,
      invVat: salVat,
      prodCompDt: row.colDt ? moment(row.colDt).format('YYYY-MM-DD') : '',
    };
  };

// [단일 요청 버튼]
const handlePublish = useCallback((row) => {
  if(row.invYn === 'Y') {
    return;
  }
  if(row.prevInvYn === 'N' || row.prevInvYn === 'S' ) {
    alert('이전 회차의 발행이 완료되지 않았습니다.');
    return;
  }
   const currentApprUuid = invoiceLines?.[0]?.apprUuid;
   if(!currentApprUuid) {
    alert('결재선 정보가 없습니다. 잠시 후 다시 시도해주세요.');
    return;
  }
  const insertData = {
    type: 'S',
    apprUuid: currentApprUuid,
    data: [mapRowToData(row)],
    searchParams: {
      [formik.values.searchKeyword]: formik.values.searchWords,
      stDt: formik.values.searchStrtDt,
      edDt: formik.values.searchEndDt,
      invYn: formik.values.searchStatus,
    }
  };
  setPendingData(insertData); // 데이터 저장
  setOpenModal(true);         // 모달 오픈
}, [formik.values, apprUuid]);

const handleBulkPublish = useCallback(() => {
  if (selectionModel.length === 0) {
    alert('발행할 항목을 선택해주세요.');
    return;
  }

  // 선택된 ID들에 해당하는 전체 데이터 객체 추출
  const selectedRows = InvoiceMaintenanceListCall.filter(row => 
    selectionModel.includes(row.id)
  );

  const hasUnpublishedPrev = selectedRows.some(row => ['N', 'S'].includes(row.prevInvYn));
  if (hasUnpublishedPrev) {
    alert('선택된 항목 중 이전 회차 발행이 완료되지 않은 건이 포함되어 있습니다.');
    return;
  }

  const insertData = {
    type: 'M', // Multiple(일괄) 구분값 (필요 시)
    apprUuid: apprUuid,
    data: selectedRows.map(mapRowToData),
    searchParams: {
      [formik.values.searchKeyword]: formik.values.searchWords,
      stDt: formik.values.searchStrtDt,
      edDt: formik.values.searchEndDt,
    }
  };

  setPendingData(insertData);
  setOpenModal(true);
}, [selectionModel, InvoiceMaintenanceListCall, formik.values, apprUuid]);

// [모달 내 '확인' 버튼]
const handleConfirm = () => {
  if (pendingData) {
    dispatch(updateBulkInvoice(pendingData));
    setOpenModal(false);
    setPendingData(null);
    setSelectionModel([]);
  }
};

  const handleInspect = useCallback((row) => {
    formik.setValues({
      ...formik.values,
      waitUuid: row.id,      
      prjUuid: row.prjUuid,
      inspectCon: 'Y' 
    });

    if (window.confirm("검수 완료 처리하시겠습니까?")) {
      const updateData = {
        waitUuid: row.id,
        prjUuid: row.prjUuid,
        inspectCon: 'Y',
        searchParams: {
        [formik.values.searchKeyword]: formik.values.searchWords,
        stDt: formik.values.searchStrtDt, // searchStrtDt (X) -> stDt (O)
        edDt: formik.values.searchEndDt,      // searchEndDt (X) -> edDt (O)
      }
      };
      
      // 리덕스 액션 실행
      dispatch(updateInvoiceMaintenance(updateData)); 
      
      // 3. 업데이트 성공 후 목록을 다시 불러오고 싶다면 
      // 리덕스 사가(Saga)나 Thunk에서 처리하거나, 여기서 직접 다시 호출
      // setTimeout(() => searchList(formik.values), 500);
    }
  }, [formik, dispatch]);

  const columns = useMemo(
  () => [
    { field: 'id', hide: true },
    { field: 'prjUuid', hide: true },
    { 
      field: 'salDt', 
      renderHeader: () => (
        <div style={{ lineHeight: 'normal', textAlign: 'center' }}>
          매출 일자<br />(계산서 작성 일자)
        </div>
      ),
      minWidth: 130, 
      align: 'center', 
      headerAlign: 'center', 
      valueFormatter: (params) => params.value?.substring(0, 10) 
    },
    { field: 'partnerNm', headerName: '매출처', minWidth: 160, align: 'left', headerAlign: 'center' },
    { field: 'partnerUuid', hide: true },
    { field: 'salDet', headerName: '사업명', minWidth: 160, align: 'left', headerAlign: 'center' },
    { 
      field: 'invNo', 
      headerName: '발행 회차', 
      width: 60, 
      align: 'center', 
      headerAlign: 'center',
      renderHeader: () => (
        <div style={{ lineHeight: 'normal', textAlign: 'center' }}>
          발행<br />회차
        </div>
      )
    },
    {
      field: 'inspectCon',
      headerName: '검수 확인',
      width: 100,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => {
        const status = params.value; // 'N', 'Y', 'S' 중 하나
        
        // 상태별 설정 (텍스트, 배경색, 클릭 가능 여부)
        const config = {
          S: { text: '검수 필요', color: '#0085da', clickable: true },  // 파란색
          Y: { text: '검수 완료', color: '#2e7d32', clickable: false }, // 초록색
          N: { text: '검수 안함', color: '#9e9e9e', clickable: false }, // 회색
        }[status] || { text: status, color: '#9e9e9e', clickable: false };

        return (
          <Button
            variant="contained"
            size="small"
            onClick={() => config.clickable && handleInspect(params.row)}
            style={{
              backgroundColor: config.color,
              color: '#ffffff',
              boxShadow: 'none',          // 그라데이션 및 입체감 제거
              borderRadius: '4px',
              fontWeight: 'bold',
              fontSize: '0.75rem',
              padding: '4px 10px',
              minWidth: '85px',
              pointerEvents: config.clickable ? 'auto' : 'none', // S가 아니면 클릭 방지
              cursor: config.clickable ? 'pointer' : 'default',
            }}
          >
            {config.text}
          </Button>
        );
      },
    },
    { field: 'osTran', headerName: '해외', width: 60, align: 'center', headerAlign: 'center' },
    { field: 'usrNm', headerName: '영업 담당자', width: 70, align: 'center', headerAlign: 'center', 
      renderHeader: () => (
        <div style={{ lineHeight: 'normal', textAlign: 'center' }}>
          영업<br/>담당자
        </div>
      )

    },
    { field: 'expSales', headerName: '계약 금액', type: 'number', width: 120, align: 'right', headerAlign: 'center', valueFormatter: (params) => params.value?.toLocaleString() },
    { field: 'salBal', headerName: '매출 잔액', type: 'number', width: 120, align: 'right', headerAlign: 'center', valueFormatter: (params) => params.value?.toLocaleString() },
    { field: 'salAmt', headerName: '매출 금액', type: 'number', width: 120, align: 'right', headerAlign: 'center', valueFormatter: (params) => params.value?.toLocaleString() },
    { field: 'salVat', headerName: '부가세', type: 'number', width: 120, align: 'right', headerAlign: 'center', valueFormatter: (params) => params.value?.toLocaleString() },
    { field: 'totalSalAmt', headerName: '매출 합계', type: 'number', width: 120, align: 'right', headerAlign: 'center', valueFormatter: (params) => params.value?.toLocaleString() },
    { field: 'colDt', headerName: '수금 예정일', minWidth: 100, align: 'center', headerAlign: 'center', valueFormatter: (params) => params.value?.substring(0, 10) },
    {
      field: 'invYn',
      headerName: '발행 여부',
      width: 80,
      align: 'center',
      headerAlign: 'center',
      renderHeader: () => (
        <div style={{ lineHeight: 'normal', textAlign: 'center' }}>
          발행<br/>여부
        </div>
      ),
      renderCell: (params) => {
        const isPendingInspect = params.row.inspectCon === 'S';
        const isPublished = params.value === 'Y';
        
        const config = isPublished 
        ? { text: '발행 완료', color: '#2e7d32' } 
        : params.value === 'S' 
          ? { text: '발행 확인중', color: '#3a46e4ec' } 
          : { 
              text: '발행 요청', 
              color: isPendingInspect ? '#9e9e9e' : '#ed6c02' 
            };

        return (
          <Button
            variant="contained"
            size="small"
            disabled={isPendingInspect} 
            style={{
              backgroundColor: config.color,
              color: '#ffffff',
              boxShadow: 'none',
              borderRadius: '4px',
              fontWeight: 'bold',
              fontSize: '0.75rem',
              padding: '4px 10px',
              minWidth: '80px',
              cursor: isPendingInspect ? 'not-allowed' : 'pointer',
            }}
            onClick={(e) => {
              e.stopPropagation();
              handlePublish(params.row);
            }}
          >
            {config.text}
          </Button>
        );
      },
    },
    {
      field: 'check',
      headerName: '선택',
      width: 70,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      align: 'center',
      headerAlign: 'center',
      renderHeader: () => {
        const selectableRows = InvoiceMaintenanceListCall?.filter(
          (r) => r.inspectCon !== 'S' && r.invYn !== 'Y' && r.invYn !== 'S'
        ) || [];

        return (
          <Checkbox
            size="small"
            checked={selectableRows.length > 0 && selectionModel.length === selectableRows.length}
            indeterminate={selectionModel.length > 0 && selectionModel.length < selectableRows.length}
            onChange={(e) => {
              if (e.target.checked) {
                setSelectionModel(selectableRows.map((row) => row.id));
              } else {
                setSelectionModel([]);
              }
            }}
          />
        );
      },
      renderCell: (params) => {
        // [잠금 조건] 검수 대기('S') 상태이거나 이미 발행 완료('Y')된 경우 체크박스 잠금
        const isLocked = params.row.inspectCon === 'S' || params.row.invYn === 'Y' || params.row.invYn === 'S';
        
        return (
          <Checkbox
            size="small"
            disabled={isLocked} // 조건에 해당하면 클릭 불가
            checked={selectionModel.includes(params.row.id)}
            onChange={(e) => {
              if (isLocked) return;
              e.stopPropagation();
              const selectedId = params.row.id;
              if (e.target.checked) {
                setSelectionModel((prev) => [...prev, selectedId]);
              } else {
                setSelectionModel((prev) => prev.filter((id) => id !== selectedId));
              }
            }}
          />
        );
      },
    },

  ],
  [handleInspect, InvoiceMaintenanceListCall, selectionModel, setSelectionModel, formik.values.searchStrtDt ], // 이 변수들이 정의되어 있는지 확인하세요.
);


  return (
    <div>
      <InoviceMaintenanceSearchBox formik={formik} handleAdd={handleBulkPublish} />
      <InvoiceMaintenanceList
        columns={columns}
        loading={loading}
        InvoiceMaintenanceList={InvoiceMaintenanceListCall}
        error={error}
        editFunction={editFunction}
        selectionModel={selectionModel}
        setSelectionModel={setSelectionModel}
        searchStrtDt={formik.values.searchStrtDt ? dayjs(formik.values.searchStrtDt).format('YYYY-MM-DD') : ''} 
      />

      {openModal && (
        <InvoiceLinModalConatiner
          title="결재라인 선택"
          open={openModal}
          approvalLines={invoiceLines}
          handleClose={handleClose}
          handleSubmit={handleConfirm}
        />
      )}
    </div>
  );
};

export default InvoiceMaintenanceListContainer;
